import type { ReactNode } from 'react';
import type { MentionKind, MentionSource } from './types';

/** How one saved mention renders: plain text for a removed entity, else a chip. */
export type MentionPresentation =
  | { type: 'missing'; label: string }
  | {
      type: 'chip';
      displayName: string;
      kind: MentionKind;
      /** The source's own icon, shown instead of the `kind` one. */
      icon?: ReactNode;
      /** Present only when clicking the chip navigates. */
      activate?: () => void;
    };

export function presentMention(
  source: MentionSource | undefined,
  id: string,
  editable: boolean,
): MentionPresentation {
  const resolved = source?.resolveDisplayName(id);
  if (resolved === undefined && source?.missingLabel !== undefined)
    return { type: 'missing', label: source.missingLabel };
  // Clicking a chip mid-edit would navigate away from the text being edited.
  const activatable =
    !editable && resolved !== undefined && source?.onActivate !== undefined;
  return {
    type: 'chip',
    displayName: resolved ?? id,
    kind: source?.resolveKind?.(id) ?? 'tool',
    icon: resolved === undefined ? undefined : source?.renderIcon?.(id),
    activate: activatable ? () => source?.onActivate?.(id) : undefined,
  };
}
